import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah M.',
  quote: 'After three months of holding my daughter for every nap, I tried the Reset Guide. Night one, she slept in her crib for 4 hours straight. I actually cried.',
  rating: 5
}, {
  name: 'Jessica T.',
  quote: 'The Vagus C-Pat changed everything. My son used to wake the second I put him down. Now he transitions smoothly and stays asleep. This is not an exaggeration—it saved my sanity.',
  rating: 5
}, {
  name: 'Emily R.',
  quote: 'I was so skeptical, but desperate. The science made sense, and the techniques actually worked. My baby sleeps, I sleep, and I feel like myself again.',
  rating: 5
}];
export function TestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 px-4 bg-beige" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl font-serif font-bold text-charcoal text-center mb-16" data-id="element-150">
          Join Thousands of Moms Who Reclaimed Their Nights
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-151">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white rounded-2xl p-8 shadow-lg" data-id="element-152">
              <div className="flex mb-4" role="img" aria-label={`${testimonial.rating} out of 5 stars`} data-id="element-153">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-coral fill-coral" aria-hidden="true" data-id="element-154" />)}
              </div>
              <blockquote className="text-charcoal/80 leading-relaxed mb-6 italic" data-id="element-155">
                "{testimonial.quote}"
              </blockquote>
              <cite className="text-charcoal font-semibold not-italic" data-id="element-156">
                — {testimonial.name}
              </cite>
            </motion.div>)}
        </div>
      </div>
    </section>;
}